import React from 'react';
import { Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
const TechnicalProofNavigationLinks = _ref => {
  let {
    claimGroup,
    user,
    page
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    as: Link,
    active: page === 'project_reports',
    to: "/".concat(user.account_type, "/claim_groups/").concat(claimGroup.id, "/technical_proof/project_reports")
  }, "Project Reports")));
};
export default TechnicalProofNavigationLinks;